import { decode } from '@msgpack/msgpack';

export interface SnapshotFile {
  path: string;
  content: Uint8Array;
}

type SnapshotNode = { d: Record<string, SnapshotNode> } | { f: { c: Uint8Array } };

export function readSnapshot(buffer: Uint8Array): SnapshotFile[] {
  const root = decode(buffer) as SnapshotNode;
  const files: SnapshotFile[] = [];
  walk(root, '', files);
  return files;
}

function walk(node: SnapshotNode, prefix: string, out: SnapshotFile[]): void {
  if ('f' in node) {
    out.push({ path: prefix, content: node.f.c ?? new Uint8Array() });
    return;
  }
  for (const [name, child] of Object.entries(node.d)) {
    const childPath = prefix ? `${prefix}/${name}` : name;
    walk(child, childPath, out);
  }
}
